module.exports = __webpack_public_path__ + "static/media/ope2.png.a625b9e2.jpg";